import type { MapTheme, TerrainOnlyTileKind, TileOwner, UnitKind } from "@dailywars/core/engine";
import { svgDataUrl, terrainSvg } from "@dailywars/core/render/svgTiles";

import {
  getBuildingIconImage,
  getBuildingIconSrc,
  getOccupiedBuildingIconImage,
} from "#/game/buildingSprites";
import { loadCachedImage } from "#/game/cachedImage";
import {
  getSpriteTerrainImage,
  getSpriteTerrainImageSrc,
  usesSpriteTerrain,
} from "#/game/terrainSprites";
import { getSpriteUnitShadowSrc, hasUnitShadow } from "#/game/unitSprites";

export function getTerrainImageSrc({
  kind,
  x,
  y,
  theme,
}: {
  kind: TerrainOnlyTileKind;
  x: number;
  y: number;
  theme?: MapTheme;
}): string {
  if (usesSpriteTerrain({ theme, kind })) {
    return getSpriteTerrainImageSrc({ theme, kind });
  }
  return svgDataUrl(terrainSvg({ kind: "plain", x, y, theme }));
}

export function getTerrainImage({
  kind,
  x,
  y,
  theme,
}: {
  kind: TerrainOnlyTileKind;
  x: number;
  y: number;
  theme?: MapTheme;
}): HTMLImageElement {
  if (usesSpriteTerrain({ theme, kind })) {
    return getSpriteTerrainImage({ theme, kind });
  }
  return loadCachedImage(svgDataUrl(terrainSvg({ kind: "plain", x, y, theme })));
}

export function getUnitShadowImageSrc(kind: UnitKind): string | null {
  if (!hasUnitShadow(kind)) return null;
  return getSpriteUnitShadowSrc(kind);
}

export function getBuildingImageSrc(
  kind: Parameters<typeof getBuildingIconSrc>[0],
  owner: TileOwner,
): string {
  return getBuildingIconSrc(kind, owner);
}

export function getBuildingImage(
  kind: Parameters<typeof getBuildingIconImage>[0],
  owner: TileOwner,
): HTMLImageElement {
  return getBuildingIconImage(kind, owner);
}

export function getOccupiedBuildingImage(
  kind: Parameters<typeof getOccupiedBuildingIconImage>[0],
  owner: TileOwner,
): HTMLImageElement {
  return getOccupiedBuildingIconImage(kind, owner);
}
